import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BlockLoadingComponent } from '@merchant-portal/app/components/loading/block-loading/block-loading.component';
import { PaginationComponent } from '@merchant-portal/app/components/pagination/pagination.component';
import { DataTableV2Component } from '@merchant-portal/app/components/table/data-table-v2/data-table-v2.component';
import { DefaultValuePipe } from '@merchant-portal/app/pipe/default-value.pipe';
import { NgxCurrencyDirective } from 'ngx-currency';
import { CardModule } from 'primeng/card';
import { DatePickerModule } from 'primeng/datepicker';
import { InputTextModule } from 'primeng/inputtext';
import { PaginatorModule } from 'primeng/paginator';
import { SelectModule } from 'primeng/select';
import { DrawerModule } from 'primeng/drawer';
import { CoreModule } from 'projects/merchant-portal/src/app/core/core.module';
import { BadgeComponent } from 'ui-component/src/lib/badge/badge.component';
import { ButtonComponent } from 'ui-component/src/lib/button/button.component';
import { StickyTableColumnComponent } from 'ui-component/src/lib/sticky-table-column';
import { InputModule } from 'ui-component/src/public-api';
import { DisbursementHistoryDetailComponent } from './disbursement-history-detail/disbursement-history-detail.component';
import { DisbursementHistoryComponent } from './disbursement-history.component';

@NgModule({
  declarations: [DisbursementHistoryComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([]),
    CardModule,
    DatePickerModule,
    CoreModule,
    FormsModule,
    InputTextModule,
    SelectModule,
    PaginatorModule,
    BlockLoadingComponent,
    NgxCurrencyDirective,
    PaginationComponent,
    DisbursementHistoryDetailComponent,
    BadgeComponent,
    ButtonComponent,
    StickyTableColumnComponent,
    InputModule,
    DataTableV2Component,
    DefaultValuePipe,
    DrawerModule,
  ],
  exports: [DisbursementHistoryComponent],
})
export class DisbursementHistoryModule {}
